import { render, staticRenderFns } from "./SThreeDotMenu.vue?vue&type=template&id=7ce58c79&lang=pug"
import script from "./SThreeDotMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SThreeDotMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports